import { useCallback } from 'react';

import { useAdsGeneratorStore } from '../model/store';
import { AdBackground, AdElement } from '../model/types';

interface SceneEditingApi {
  /**
   * Zmiana elementu. `key` włącza sklejanie historii, więc jedno przeciągnięcie
   * suwaka to jeden krok cofania zamiast kilkudziesięciu.
   */
  patchElement: (id: string, patch: Partial<AdElement>, key?: string) => void;
  patchBackground: (patch: Partial<AdBackground>, key?: string) => void;
}

export const useSceneEditing = (): SceneEditingApi => {
  const commit = useAdsGeneratorStore((state) => state.commit);
  const updateElement = useAdsGeneratorStore((state) => state.updateElement);
  const setBackground = useAdsGeneratorStore((state) => state.setBackground);

  const patchElement = useCallback((id: string, patch: Partial<AdElement>, key?: string) => {
    commit(key);
    updateElement(id, patch, true);
  }, [commit, updateElement]);

  const patchBackground = useCallback((patch: Partial<AdBackground>, key?: string) => {
    commit(key);
    setBackground(patch, true);
  }, [commit, setBackground]);

  return { patchElement, patchBackground };
};
